export const MESSAGE_TYPES = {
  TOKEN_EXPIRATION: 'tokenExpiration',
  WHATSAPP_QR_CODE_CHANGE: 'whatsAppQrCodeChange',
  SERVICE_STATUS_UPDATE: 'serviceStatusUpdate',
  USER_CONNECTED: 'userConnected',
  USER_DISCONNECTED: 'userDisconnected',
  USER_BREAK_START: 'userBreakStart',
  USER_BREAK_END: 'userBreakEnd',
  USER_BREAK_WARNING: 'userBreakWarning',
  DASHBOARD_UPDATE: 'dashboardUpdate',
  CHAT_ASSIGNMENT: 'chatAssignment',
  CHAT_TRANSFER: 'chatTransfer',
  CHAT_FINALIZATION: 'chatFinalization',
  PABX_STATE_UPDATE: 'pabxStateUpdate',
  INCOMING_MESSAGES: 'incomingMessages',
  MESSAGE_UPDATE: 'messageUpdate',
  VIDEO_SCHEDULE: 'videoSchadule',
  USER_WAITING_FOR_PAUSE: 'userwaitingForBreak',
  USER_CANCEL_WAITING_FOR_PAUSE: 'userCancelwaitingForBreak',
};
